import * as Auth from './auth';
import * as Styles from './styles';

export default {
  Auth,
  Styles,
};
